import { render, staticRenderFns } from "./SignerCard.vue?vue&type=template&id=4d27df96&scoped=true"
import script from "./SignerCard.vue?vue&type=script&lang=js"
export * from "./SignerCard.vue?vue&type=script&lang=js"
import style0 from "./SignerCard.vue?vue&type=style&index=0&id=4d27df96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d27df96",
  null
  
)

export default component.exports